export class GetEmailAcknowledgeStatus {
  static readonly type = '[EmailAcknowledgement] GetEmailAcknowledgeStatus';

  constructor(public token: string) {}
}

export class SubmitEmailAcknowledge {
  static readonly type = '[EmailAcknowledgement] SubmitEmailAcknowledge';

  constructor(public token: string) {}
}
